export default __webpack_public_path__ + "static/media/custom-negative.d1fc37c7.svg";